import Button from "@/components/button/Button"
import { useAuth } from "@/components/context/AuthProvider"
import { useModalDarkContext } from "@/components/context/ModalDarkContext"
import { SvgIcon } from "@/components/icon"
import { globalMutationsFetchPolicy } from "@/components/layout/fetchPolicies"
import WebsiteTypography from "@/components/websiteTypography/WebsiteTypography"
import { useSendLicenseUpdateRequestMutation } from "@/graphql"
import { Col, Row, message } from "antd"
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint"
import { FC } from "react"

const { Title, Paragraph } = WebsiteTypography

const LicenceUpgradeRequest: FC = () => {
  const { xxl, xl } = useBreakpoint()
  const { setModalDarkTypes } = useModalDarkContext()
  const { user } = useAuth()
  const [sendLicenseUpdateRequest, { loading }] = useSendLicenseUpdateRequestMutation()

  const handleOnSendRequest = async () => {
    if (user?.userProfile?.data?.id) {
      await sendLicenseUpdateRequest({
        fetchPolicy: globalMutationsFetchPolicy,
        variables: {
          input: {
            userProfileId: user?.userProfile?.data?.id,
          },
        },
        onCompleted: () => {
          setModalDarkTypes("success")
        },
        onError: error => {
          message.error(error.message)
        },
      })
    }
  }

  return (
    <Row justify={"center"}>
      <Col span={20} xxl={20} xl={20} lg={20} md={24} sm={24} xs={24}>
        <Row justify={"center"} style={{ paddingBottom: 24 }}>
          <SvgIcon type={"license"} color={"green"} />
        </Row>

        <Title level={!(xxl || xl) ? 4 : 3} centered className={"form-section-title"}>
          <span className={"bold"}>{"License Upgrade "}</span>
          <span className={"w300"}>{"Request"}</span>
        </Title>

        <Paragraph centered size={!(xxl || xl) ? "md" : "lg"} style={{ paddingTop: 24 }} color={"website-secondary"}>
          {
            "By clicking Send Request below, you agree to submit a license upgrade request. Our team will be in touch shortly to assist you with the transition."
          }
        </Paragraph>
      </Col>

      <Col span={24} style={{ paddingTop: 32 }}>
        <Row justify={"center"}>
          <Button
            btnType={"primary"}
            text={"Send Request".toUpperCase()}
            onClick={handleOnSendRequest}
            loading={loading}
          />
        </Row>
      </Col>
    </Row>
  )
}

export default LicenceUpgradeRequest
